import {
  createMsalConfig,
  createLoginRequest,
  createApiTokenRequest,
} from "@preppa/shared-auth";
import { getDeviceLoginHint } from "./deviceLoginHint";

const apiScope = process.env.REACT_APP_MSAL_KITCHEN_API_SCOPE || "";

if (!apiScope) {
  console.warn(
    "[authConfig] REACT_APP_MSAL_KITCHEN_API_SCOPE is not set. API token acquisition may fail.",
  );
}

export const msalConfig = createMsalConfig({
  clientId: process.env.REACT_APP_MSAL_KITCHEN_CLIENT_ID || "",
  authority: process.env.REACT_APP_MSAL_AUTHORITY || "",
  redirectUri:
    process.env.REACT_APP_MSAL_KITCHEN_REDIRECT_URI || window.location.origin,
  apiScope,
});


export const loginRequest = createLoginRequest(apiScope, getDeviceLoginHint());
export const apiTokenRequest = createApiTokenRequest(apiScope);
